import React from 'react'

export default function StyledPaper({ ...props }) {
  return <div
    className="bg-zinc-100 p-2 sm:rounded"
    {...props} />
}